import { render } from "./PeriodTable.vue?vue&type=template&id=369441a2"
import script from "./PeriodTable.vue?vue&type=script&lang=js"
export * from "./PeriodTable.vue?vue&type=script&lang=js"

import "./PeriodTable.vue?vue&type=style&index=0&id=369441a2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__